<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import tooltipDirective from '@lib/directives/tooltip'
import type { ViewCompactFileFolder } from '@lib/types/files'
import useAppStore from '@browser/stores/app'
import useThemeVars from '@lib/composables/useThemeVars'

const { toggleItemFavorite } = useAppStore()
const themeVars = useThemeVars()
const { t } = useI18n()
const vTooltip = tooltipDirective

defineProps<{ item: ViewCompactFileFolder }>()
</script>
<template>
  <CButton
    v-tooltip="
      !!item.favoriteId
        ? t('canvasUI.browserApp.foldersFilesTable.removeFromFavorites')
        : t('canvasUI.browserApp.foldersFilesTable.addToFavorites')
    "
    circle
    class="h-9 w-9"
    :color="!!item.favoriteId ? themeVars.accent : themeVars.primary"
    :secondary="!item.favoriteId"
    type="default"
    @click.stop="toggleItemFavorite(item as ViewCompactFileFolder)"
  >
    <template #icon>
      <CIcon :fa-type="item.favoriteId ? 'fas' : undefined" icon="heart" size="12px" />
    </template>
  </CButton>
</template>
